<template>
	<div>
		<header-top></header-top>
		<index-tab></index-tab>
		<router-view></router-view>
	</div>
</template>
<script>
	import headerTop from '../components/Header'
	import IndexTab from '../components/IndexTab'

	export default {
		components: {
			headerTop,
			IndexTab
		}
	}
</script>


// WEBPACK FOOTER //
// Index.vue?c288fbce